import { useCallback, useEffect, useState } from 'react';
import landlordService from '../services/landlordService';

const KEY = 'currentOrganisationId';

const readStored = () => {
  try {
    return localStorage.getItem(KEY) || '';
  } catch (e) {
    return '';
  }
};

// The organisation the person is working in. Most people have one; if they have several we remember the choice.
const useOrganisation = () => {
  const [organisations, setOrganisations] = useState(null);
  const [selectedId, setSelectedId] = useState(readStored());
  const [error, setError] = useState('');

  useEffect(() => {
    landlordService
      .organisations()
      .then((data) => setOrganisations(Array.isArray(data) ? data : data?.data || []))
      .catch(() => {
        setOrganisations([]);
        setError('Your organisations could not be loaded.');
      });
  }, []);

  const organisation =
    organisations?.find((o) => String(o.id) === String(selectedId)) || organisations?.[0] || null;

  const select = useCallback((id) => {
    setSelectedId(String(id));
    try {
      localStorage.setItem(KEY, String(id));
    } catch (e) {
      // remembering the choice is a convenience only
    }
  }, []);

  return { organisations, organisation, select, loading: organisations === null, error };
};

export default useOrganisation;
